var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnHold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 17.82,
    y: 7.4,
    width: 2.85,
    height: 6.9,
    style: {
      fill: "#9868b9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.81,
    y: 7.4,
    width: 2.85,
    height: 6.9,
    style: {
      fill: "#9868b9"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.6,6.88C8,7.79,7.27,9.66,7.34,12.23a15.64,15.64,0,0,0,2.19,6.9,15.48,15.48,0,0,0,4.8,5.31c2.07,1.4,4.15,1.64,5.76.75h0l1.07-.68a1.05,1.05,0,0,0,.38-1.38l-2.08-3.62a1.07,1.07,0,0,0-1.39-.38l-1.13.59c-.5.28-2.46.22-4-2.59s-.77-4.48-.19-4.79l1.14-.58a1,1,0,0,0,.38-1.39l-2-3.58a1,1,0,0,0-1.38-.38C10.77,6.24,9.6,6.88,9.6,6.88Z",
    style: {
      fill: "#7e7e7e"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnHold);
export default __webpack_public_path__ + "static/media/on-hold.b2a01f96.svg";
export { ForwardRef as ReactComponent };